// extracted by mini-css-extract-plugin
export var button = "_l5-0";
export var donut = "_l5-1";
export var donutFill = "_l5-3";
export var donutTrack = "_l5-2";